import { type FC } from 'react'
import { FontWeight } from '@opallabs/gem'
import type { StrongTextProps } from '../types'
import { styles } from './styles'

export { type StrongTextProps }

export const StrongText: FC<React.PropsWithChildren<StrongTextProps>> = ({
  children,
  className,
  fontWeight = FontWeight.Bold,
  styleOverrides,
}) => (
  <strong className={className} css={[styles(fontWeight), styleOverrides]}>
    {children}
  </strong>
)
StrongText.displayName = 'Lapidary: StrongText'
